export default __webpack_public_path__ + "static/media/zoomed_diagonaldown_lighttodark.7fbdbd4d.png";